import React from 'react'
import Text from '../../components/common/Text'
import styled from '@emotion/styled'
import { BLACK, FONT_LIGHT_GRAY, WHITE } from '../../constant/colors'
import Breadcrumb from '../../components/common/Breadcrumb'
import { useTranslation } from 'react-i18next'
import IconPhone from '../../assets/images/icons-phone-navigation-black.svg'
import IconEmail from '../../assets/images/icons-mail-navigation-black.svg'
import IconHome from '../../assets/images/icons-home-navigation-black.svg'
import { useScreen } from '../../utils/responsive-helper'

const BreadcrumbLayout = styled.div`
  margin-top: 24px;
  margin-bottom: 24px;
`

const ContentLayout = styled.div`
  background-color: ${WHITE};
  // height: 100%;
  margin-bottom: 10px;
  padding: 32px;
  border-radius: 8px;
`

const CenterLayout = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  /* border: 1px solid #000000; */
  margin-bottom: 24px;
`

const WhiteLine = styled.div`
  height: 20px;
`

const Contact = () => {
  const { t } = useTranslation()
  const { isMobile } = useScreen()

  return (
    <>
      <BreadcrumbLayout>
        <Breadcrumb
          overide={(paths) => {
            paths = [
              { label: 'Home', path: '/' },
              { label: t('contact.header'), path: '/contact' },
            ]
            return paths
          }}
        />
      </BreadcrumbLayout>
      <CenterLayout>
        <Text size={28} type="Bold">
          {t('contact.header')}
        </Text>
      </CenterLayout>
      <ContentLayout>
        <Text size={24} type="Bold">
          BELIVE
        </Text>
        <WhiteLine />
        <div
          style={{
            borderWidth: 0,
            borderColor: BLACK,
            borderStyle: 'solid',
            display: 'grid',
            gridTemplateColumns: isMobile ? 'fit-content(100%)' : '300px auto',
          }}
        >
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'flex-start',
              marginBottom: 16,
            }}
          >
            <img src={IconPhone} style={{ marginRight: 8 }} alt="phone icon" />
            <Text size={20} color={FONT_LIGHT_GRAY} type="Medium">
              {t('contact.phoneLabel')} :{' '}
            </Text>
            <Text size={20} style={{ marginLeft: 8 }} type="Medium">
              0959998888
            </Text>
          </div>

          <div
            style={{
              borderWidth: 0,
              borderColor: BLACK,
              borderStyle: 'solid',
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'flex-start',
              marginBottom: 16,
            }}
          >
            <img src={IconEmail} style={{ marginRight: 8 }} alt="email icon" />
            <Text size={20} color={FONT_LIGHT_GRAY} type="Medium">
              {t('contact.emailLabel')} :{' '}
            </Text>
            <Text size={20} style={{ marginLeft: 8 }} type="Medium">
              surachet@belive.com
            </Text>
          </div>
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: '115px auto' }}>
          <div style={{ display: 'flex', flexDirection: 'row', height: 20 }}>
            <img src={IconHome} style={{ marginRight: 8 }} alt="home icon" />
            <Text size={20} color={FONT_LIGHT_GRAY} type="Medium">
              {t('contact.addressLabel')} :
            </Text>
          </div>
          <Text size={20} style={{ marginLeft: 4 }} type="Medium">
            12/21 จีคอนโด อารีย์ซอย 16 แขวงพญาไท เขตสามเสนใน กรุงเทพมหานคร 11110{' '}
          </Text>
        </div>
      </ContentLayout>
    </>
  )
}

export default Contact
